import type { IPublicClientApplication } from '@azure/msal-browser';
import type { AuthEnvironment } from '../../services/auth/AuthEnvironmentResolver';
import type { ProviderServices } from '../../services/chat/createProviderServices';

export interface PlaywrightTestSetupOverrides {
    environment?: AuthEnvironment;
    createMsalInstance?: (
        environment: AuthEnvironment,
    ) => IPublicClientApplication | Promise<IPublicClientApplication>;
    createProviderServices?: () => ProviderServices;
}

declare global {
    interface Window {
        __PLAYWRIGHT_TEST_SETUP__?: PlaywrightTestSetupOverrides;
        __E2E_TEST_EVENTS__?: Array<Record<string, unknown>>;
    }
}

export const getPlaywrightTestSetup = (): PlaywrightTestSetupOverrides | undefined => {
    if (typeof window === 'undefined') {
        return undefined;
    }

    return window.__PLAYWRIGHT_TEST_SETUP__;
};